//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^React読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
import React, { useContext, useEffect, useState } from "react";
//_________________________________________________React読み込み_________________________________________________//

//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^react-router-dom関連読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
import { useNavigate } from "react-router-dom";
//_________________________________________________react-router-dom関連読み込み_________________________________________________//

//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ライブラリの読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
//_________________________________________________ライブラリの読み込み_________________________________________________//

//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^MUI読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
import { Button, Box } from "@material-ui/core";
//_________________________________________________MUI読み込み_________________________________________________//

//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^Api読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
import { api } from "../../api/api";
//_________________________________________________Api読み込み_________________________________________________//

//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^コンポーネント読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
import DataTable from "../../components/DataTable";
import BackButton from "../../components/BackButton";
import CloseButton from "../../components/CloseButton";
import FreeWordSearch from "../../components/FreeWordSearch";
//_________________________________________________コンポーネント読み込み_________________________________________________//

//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^コンテクスト読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
import { UserContext } from "../../providers/UserProvider";
//_________________________________________________コンテクスト読み込み_________________________________________________//

//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^共通関数・定数の読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
import { HOME_PATH } from "../../common/constants";
import processResponse from "../../common/processResponse";
import processErrorResponse from "../../common/processErrorResponse";
import { checkAuthorities } from "../../common/checkAuthorities";
//_________________________________________________共通関数・定数の読み込み_________________________________________________//

//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^コンポーネント内で扱う定数の定義^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
// 戻るときの遷移先のパス
const returnPath = HOME_PATH;

//---------------------------issue{No.102} start-----------------------------
//見出しの配列のパターンを定義
const initHeaders = ["ユーザー名", "権限", "照会"];
const initHeadersOfButtons = ["編集", "削除"];
//---------------------------issue{No.102} end-------------------------------

// 検索対象のカラムの配列定義
const columns = ["user_name", "user_email", "authority_name"];
//_________________________________________________コンポーネント内で扱う定数の定義_________________________________________________//

//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ステートの初期値を定義^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
// users の初期状態
const initUsers = { result: [], success: false };
//_________________________________________________ステートの初期値を定義_________________________________________________//

//=====================================================関数コンポーネントここから=====================================================//
export default function User() {
    //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^スタイルの定義を読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
    //_________________________________________________スタイルの定義を読み込み_________________________________________________//

    //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^react-router-domに関する機能を読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
    // 画面遷移用
    const navigate = useNavigate();
    //_________________________________________________react-router-domに関する機能を読み込み_________________________________________________//

    //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^useContextに関する機能を読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
    // ログイン中のユーザー情報を取得
    const { userInfo } = useContext(UserContext);
    const userAuthorityNumber = userInfo.user.authority_number; // 権限
    const loggedInUserId = userInfo.user.user_id; // id
    //_________________________________________________useContextに関する機能を読み込み_________________________________________________//

    //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^URLに含まれるパラメーターを読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
    //_________________________________________________URLに含まれるパラメーターを読み込み_________________________________________________//

    //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^propsを読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
    //_________________________________________________propsを読み込み_________________________________________________//

    //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^読み込んだ共通関数・定数を読み込み^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
    const { checkAdmin } = checkAuthorities;
    //_________________________________________________読み込んだ共通関数・定数を読み込み_________________________________________________//

    //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^各種ステートやRefオブジェクトを定義^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
    // users の状態を管理する
    const [users, setUsers] = useState(initUsers);

    // users を表示行に変換したものを保持する
    const [rows, setRows] = useState([]);

    // 検索されたユーザーのデータを格納するステート
    const [searchedUsers, setSearchedUsers] = useState([]);

    // 見出しの配列を保持するステート
    const [headers, setHeaders] = useState(initHeaders);

    // ボタン表示フラグ
    const [displayButtons, setDisplayButtons] = useState(false);
    //_________________________________________________各種ステートやRefオブジェクトを定義_________________________________________________//

    //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^DB接続に関する関数の記述^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
    // 情報を取得しステート users にセットする
    const getUsersData = async () => {
        const url = "users";
        const res = await api.get(url);
        // resの内容に応じて処理を行う
        processResponse(res, setUsers, navigate, returnPath);
    };
    //_________________________________________________DB接続に関する関数の記述_________________________________________________//

    //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^イベントハンドラーの定義^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
    //  新規登録ボタンクリック時
    const handleOnClickRegister = (e) => {
        // イベントの伝搬を中止
        e.preventDefault();

        // 新規登録画面へ進む
        navigate(`/register`);
    };

    // 復活ボタンクリック時
    const handleOnClickRestore = (e) => {
        // イベントの伝搬を中止
        e.preventDefault();

        // 削除済み一覧へ進む
        navigate(`/user_deleted`);
    };

    // 一覧の編集ボタンをクリックしたら、ユーザー情報編集画面へ
    const handleOnClickEdit = (e, id) => {
        // イベントの伝搬を中止
        e.stopPropagation();

        // 編集画面へ進む
        navigate(`/user/edit/${id}`);
    };

    // 一覧の削除ボタンクリック時に、
    // ユーザーを論理削除する
    const handleOnClickDelete = async (e, id) => {
        // イベントの伝搬を中止
        e.stopPropagation();

        // 削除対象のユーザーの情報を取得
        const user = users.result.find((user) => user.user_id === id);
        // 表示用の名前を宣言
        const userName = user.user_name;

        // 確認のための変数を定義
        let confirm = false;

        // 確認画面を表示
        await swal({
            icon: "info",
            title: "ユーザーを削除しますか？",
            text: userName,
            buttons: ["キャンセル", "実行"],
        }).then((value) => {
            if (value) {
                confirm = true;
            }
        });

        // キャンセルの場合は処理を中断する
        if (!confirm) {
            return;
        }

        //論理削除
        const url = `users/${id}`;
        const res = await api.delete(url);
        //---------------------------issue{No.81} start-----------------------------
        // 成否の確認
        if (res.data.success) {
            // 削除成功時
            // モーダルウィンドウで成功メッセージを表示
            swal(res.data.message, "", "success").then(() => {
                // 削除したユーザを除外した全ユーザを配列化
                const newUsers = users.result.filter((user) => user.user_id !== id);
                // ステートを更新
                setUsers({ result: newUsers, success: true });
            });
        } else {
            // 削除失敗時にエラーに応じた処理を行う
            processErrorResponse(res, () => {}, navigate);
        }
        //---------------------------issue{No.81} end-------------------------------
    };

    // 行のデータ部分をクリック時、ユーザ情報画面へ
    const handleOnClickShow = (e, id) => {
        // イベントの伝搬を中止
        e.stopPropagation();

        // usersの内、クリックした行のユーザのidと一致するユーザのidをusersステートから変数に代入
        const user = users.result.find((user) => user.user_id === id);
        // userに値が存在する場合
        if (user) {
            // ユーザー情報画面へ進む
            navigate(`/user/show/${id}`);
        }
    };
    //_________________________________________________イベントハンドラーの定義_________________________________________________//

    //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^読み込み時の一度きりの副作用フックを記述^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
    useEffect(() => {
        //画面初期表示時にユーザー情報を取得する
        getUsersData();

        // 権限ごとにステート（ボタン表示フラグ及びログインユーザー情報）を調整(初回のみ実行)
        // 管理者以上
        //---------------------------issue{No.63} start-----------------------------
        if (checkAdmin(userAuthorityNumber)) {
            setDisplayButtons(true);
            //---------------------------issue{No.102} start-----------------------------
            setHeaders([...initHeaders, ...initHeadersOfButtons]);
            //---------------------------issue{No.102} end-------------------------------
        }
        //---------------------------issue{No.63} end-------------------------------
    }, []);
    //_________________________________________________読み込み時の一度きりの副作用フックを記述_________________________________________________//

    //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^コンポーネント独自の関数など^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^//
    // searchedUsersに応じて、画面表示用の配列を生成
    useEffect(() => {
        if (!searchedUsers || !users.success) {
            return;
        }

        const newRows = searchedUsers.map((user) => {
            let targetUserId = user.user_id; // 各ユーザーのid
            let targetUserAuthorityNumber = user.authority_number; // 各ユーザーの権限の数値
            let isOther = true; // 他ユーザーフラグ
            let isSubordinateSuperiorAuthority = true; // 下位権限フラグ

            // 自身の場合、他ユーザーフラグをfalseに変更
            if (loggedInUserId === targetUserId) {
                isOther = false;
            }

            // 自分より上位の権限の場合、false（自分と同じ権限の権限の場合はtrueのまま）
            if (userAuthorityNumber > targetUserAuthorityNumber) {
                isSubordinateSuperiorAuthority = false;
            }

            const row = {
                id: user.user_id,
                isActive: true,
                data: {
                    name: user.user_name,
                    authority: user.authority_name,
                    //---------------------------issue{No.102} start-----------------------------
                    showBtn: (
                        <Button variant='contained' color='primary' onClick={(e) => handleOnClickShow(e, user.user_id)}>
                            照会
                        </Button>
                    ),
                    //---------------------------issue{No.102} end-------------------------------
                    // ボタン表示フラグ・下位権限フラグ共にtrueの場合のみボタンを表示
                    editBtn:
                        displayButtons && isSubordinateSuperiorAuthority ? (
                            <Button
                                variant='contained'
                                color='primary'
                                onClick={(e) => handleOnClickEdit(e, user.user_id)}>
                                編集
                            </Button>
                        ) : (
                            <span>-</span>
                        ),
                    // ボタン表示フラグ・他ユーザーフラグ・下位権限フラグの全てがtrueの場合のみボタンを表示
                    deleteBtn:
                        displayButtons && isOther && isSubordinateSuperiorAuthority ? (
                            <Button variant='contained' onClick={(e) => handleOnClickDelete(e, user.user_id)}>
                                削除
                            </Button>
                        ) : (
                            <span>-</span>
                        ),
                },
            };

            // 編集・削除のボタンを表示しない場合はボタン要素のプロパティを削除
            if (!displayButtons) {
                delete row.data.editBtn;
                delete row.data.deleteBtn;
            }

            return row;
        });

        setRows(newRows);
    }, [searchedUsers]);
    //_________________________________________________コンポーネント独自の関数など_________________________________________________//

    //=====================================================JSXここから=====================================================//
    return (
        <div className='row justify-content-center'>
            <div className='col-md-12'>
                <div className='card'>
                    <div className='card-header d-flex'>
                        <h1>ユーザー情報一覧</h1>
                        <div className='ms-auto'>
                            <CloseButton path={returnPath} />
                        </div>
                    </div>
                    <div className='card-body'>
                        {displayButtons && (
                            <Box className='card-body' sx={{ display: "flex", width: "max-content", ml: "auto" }}>
                                <Button variant='contained' color='primary' onClick={(e) => handleOnClickRegister(e)}>
                                    新規登録
                                </Button>
                                <Button className='ms-3' variant='contained' onClick={(e) => handleOnClickRestore(e)}>
                                    削除済み一覧
                                </Button>
                            </Box>
                        )}
                        <FreeWordSearch
                            searchColumns={columns}
                            data={users.result}
                            setSearchedData={setSearchedUsers}
                        />
                        <DataTable headers={headers} rows={rows} />
                    </div>
                    <div className='card-footer'>
                        <div className='form-group mb-3 d-flex'>
                            <BackButton path={returnPath} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
